<template>
  <div>
    <v-overlay :value="isLoading"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>
    <!-- MENU CONTAINER SECTION BACKGROUND -->
    <div class="menu_container_section_background">
      <div class="col-md-12 menu_container_section_container">
        <div v-for="(menu, index) in itensMenuAdministrador" :key="index" class="menu_container_section_"
          @click="handleClick(menu)">
          <div v-if="menu.novo == 1" class="novo-badge-item-menu">Novo</div>
          <figure class="menu_container_section_img">
            <img :src="menu.icon" />
          </figure>
          <div class="menu_container_section_text_container">
            <span class="menu_container_section_text_title">{{ menu.descricao }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
const ls = require('local-storage')
import ItensMenuUtilitarios from '@/utilitarios/ItensMenuUtilitarios';
export default {

  data: () => ({
    itensMenuAdministrador: [],
    isLoading: false
  }),

  computed: {
    islicencaExpirada() {
      return ls.get('licencaExpirada')
    }
  },


  async created() {
    this.isLoading = true;
    try {
      this.$store.state.idclasse = null
      this.itensMenuAdministrador = await ItensMenuUtilitarios.getItensByMenu(10);
    } catch (error) {
      Swal.fire(
        'Informação',
        'Erro ao carregar a página!',
        'error'
      );

    } finally {
      this.isLoading = false;
    }
  },

  methods: {
    handleClick(menu) {
      if (menu.validarLicenca == 1) {
        if (this.islicencaExpirada == 1) {
          Swal.fire(
            'Informação',
            'A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!',
            'info'
          );
          return;
        }
      }
      if (menu.isRota == 1) {
        this.$router.push(menu.url);
      } else if (menu.funcao) {
        eval(menu.funcao);
      }
    },

    IndisponivelMomento() {
      Swal.fire('Informação', 'Funcionalidade indisponível de momento.', 'warning')
    }
  }
}
</script>
